import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

@NgModule({
  imports: []
})
export class ErrorsModule {
  static forRoot(rootErrorsProvider?: Provider): ModuleWithProviders<ErrorsModule> {
    return {
      ngModule: ErrorsModule,
      providers: [rootErrorsProvider]
    };
  }
}
